import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { CsValueDebug } from "@plansoft-configuration-renderer/debug";
import { LayoutGridType } from "../ReactPageLayout/LayoutGridType";
import { LayoutRows } from "../ReactPageLayout/LayoutRows";
/**
 * Wrapper for the controls's children (values and debug)
 */
const MuiControlCellChildren = styled("div", {
    name: "MuiControlCellChildren",
    slot: "root",
})(({ theme }) => ({
    display: "inline-flex", // to integrate with radio / checkbox FormControlLabel
    width: "100%", // else this collapses to the minimum width for flexbox grid
    columnGap: theme.spacing(1),
}));
/**
 * Wrapper for the controls value
 */
const MuiControlCellValue = styled("div", {
    name: "MuiControlCellValue",
    slot: "root",
})({
    flex: "1 1 auto", // grow the area for the value content
});
// temporary solution for aligning radio and checkbox options
const gridContainerProps = {
    sx: { alignItems: "center" },
    rowSpacing: 0,
    columnSpacing: 2,
};
/**
 * Layout cell in react-page layout
 * @param props
 * @returns
 */
export function ControlCellChildrenInline(props) {
    const { rows } = props;
    return (_jsxs(MuiControlCellChildren, { children: [_jsx(CsValueDebug, { chipSx: { flex: "0 0  auto" } }), _jsx(MuiControlCellValue, { children: _jsx(LayoutRows, { rows: rows, gridContainer: gridContainerProps, gridType: LayoutGridType.Control }) })] }));
}
//# sourceMappingURL=ControlCellChildrenInline.js.map